var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.335,
    height: 20.7,
    viewBox: "0 0 22.335 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0055ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -17.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.7,228.245a.637.637,0,0,0-.64.64v5.821a2.872,2.872,0,0,1-2.868,2.868H4.148a2.872,2.872,0,0,1-2.868-2.868V228.79a.64.64,0,0,0-1.28,0v5.916a4.152,4.152,0,0,0,4.148,4.148h14.04a4.152,4.152,0,0,0,4.148-4.148v-5.821A.64.64,0,0,0,21.7,228.245Z",
    transform: "translate(0 -218.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.485,32.869a.644.644,0,0,0,.45.19.624.624,0,0,0,.45-.19l4.067-4.067a.64.64,0,0,0-.905-.905l-2.972,2.977V17.89a.64.64,0,0,0-1.28,0V30.873L137.319,27.9a.64.64,0,0,0-.905.905Z",
    transform: "translate(-129.768 -17.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9afaffcc.svg";
export { ForwardRef as ReactComponent };